// extracted by mini-css-extract-plugin
export default {"appicon":"appicon_fad14404b3ad489d61ec","icon":"icon_adcac2726e084d199773","name":"name_e0f4c56afb78b8858375"};